import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { WidgetEntry } from '../types';

// Widget weight per MZ-586 — tie-breaker within the CashOffer/MonetizationEvent priority
// bucket, deliberately below monetization event-trigger weights (~1000) so those render first.
const CASH_OFFER_WIDGET_WEIGHT = 200;

// Lobby entry for the game-ui-hosted dynamic cash offer popup. Eligibility
// (flag + cash-winnings mode + an offer on the wallet) is shared with the auto-popup via CashOfferStore.
export function useCashOfferWidgets() {
  const { cashOfferStore } = useStores();
  const isEligible = cashOfferStore.isEligible;

  return useMemo((): WidgetEntry<'cashOffer'>[] => {
    if (!isEligible) {
      return [];
    }
    return [
      {
        data: { key: 'cash-offer', dataTestId: 'cash-offer-widget', weight: CASH_OFFER_WIDGET_WEIGHT },
        type: 'cashOffer',
        id: 'cash-offer',
      },
    ];
  }, [isEligible]);
}
